import React from 'react';
import { useDispatch } from 'react-redux';

import { Button, Col, Form, Input, Modal, Row } from 'antd';

import { EditGuideStatus } from 'app/redux/actions/initiatives';

const EditGuideStatusModal = ({ show, setShow, data, setData }) => {
  const dispatch = useDispatch();

  const Close = () => {
    setData(null);
    setShow(false);
  };

  const onFinish = async values => {
    await dispatch(EditGuideStatus(data.pk, values));
    window.location.reload();
  };

  return (
    <Modal footer={null} open={show} onCancel={Close} width="600px">
      <div className="modal-body">
        <Form onFinish={onFinish}>
          <Form.Item
            name="title"
            label="Title"
            rules={[{ required: true }]}
            initialValue={data.title}
          >
            <Input showCount maxLength={255} />
          </Form.Item>

          <Form.Item
            name="description"
            label="Description"
            rules={[{ required: true }]}
            initialValue={data.description}
          >
            <Input showCount maxLength={255} />
          </Form.Item>

          <Row gutter={(4, 4)}>
            <Col>
              <Form.Item labelCol={{ span: 6 }}>
                <Button type="primary" htmlType="submit">
                  Submit
                </Button>
              </Form.Item>
            </Col>
            <Col>
              <Form.Item wrapperCol={{ span: 6 }}>
                <Button
                  onClick={() => {
                    setData(null);
                    Modal.destroyAll();
                  }}
                >
                  Cancel
                </Button>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </div>
    </Modal>
  );
};

export default EditGuideStatusModal;
